import React from "react";
import { useState, useEffect } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import "./style.css";
import { VscHeartFilled } from "react-icons/vsc";
// import "bootstrap/dist/css/bootstrap.min.css"

const DAYS = {
  days: "દિવસ",
  hours: "કલાક",
  minutes: "મિનિટ",
  seconds: "સેકન્ડ",
};

const FancyWeddingCountdownTimer = ({ guestName = "Guest Name" }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  guestName = guestName?.replace(/_/g, ' ');
  // Set your wedding date here (format: YYYY, MM-1, DD, HH, MM, SS)
  const weddingDate = new Date(2025, 2 - 1, 25, 17, 0, 0).getTime();

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = weddingDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      } else {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [weddingDate]);

  return (
    <div className="fancy-wedding-countdown">
      <Container className="py-5">
        <h1 style={{ color: "white" }}>
          તીર્થરાજસિંહ{" "}
          <span>
            <VscHeartFilled
              style={{ paddingTop: "2px" }}
              color="rgb(250, 115, 115)"
            />{" "}
          </span>{" "}
          ભવ્યતાબા
        </h1>

        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="text-center fancy-card">
              <Card.Body>
                <h1 className="mb-4 fancy-title">કાઉન્ટડાઉન</h1>
                <Row className="countdown-row">
                  {Object.entries(timeLeft).map(([unit, value]) => (
                    <Col key={unit} xs={6} md={3} className="mb-3">
                      <div className="countdown-item">
                        <div className="countdown-value">{value}</div>
                        <div className="countdown-unit">{DAYS[unit]}</div>
                      </div>
                    </Col>
                  ))}
                </Row>
                <p className="mt-4 fancy-text">
                  <h2>અમારા લગ્નના શુભ અવસરે <b>{(guestName===undefined)? "આપશ્રી" :`શ્રી ${guestName}` }</b> ને ભાવભર્યુ આમંત્રણ </h2>
                </p>
                <div className="hearts">
                  <div className="heart"></div>
                  <div className="heart"></div>
                  <div className="heart"></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FancyWeddingCountdownTimer;
